module.exports = __webpack_public_path__ + "static/media/Тимиргалеев С. (ДУ).7b71f94e.pdf";